import React, { useState } from 'react';
import { api } from '../lib/api';
import { useAuth } from '../context/AuthContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiX, FiAlertTriangle, FiSend } = FiIcons;

const FlagNLAModal = ({ part, onClose, onSuccess }) => {
  const { user } = useAuth();
  const [notes, setNotes] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user) return alert("You must be logged in to flag parts.");
    
    setIsSubmitting(true);

    // The server records the submitter from the session; the client only sends the part and notes
    let error = null;
    try {
      await api('createTicket', { part_id: part.id, tech_notes: notes });
    } catch (err) {
      error = err;
    }

    if (error) {
      if (error.code === 'duplicate') {
        alert('This part is already flagged for review.');
      } else {
        alert('Error submitting ticket: ' + error.message);
      }
    } else {
      onSuccess();
    }
    
    setIsSubmitting(false);
  };

  return (
    <div 
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-950/90 backdrop-blur-md"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="bg-slate-900 border border-slate-800 rounded-3xl w-full max-w-md shadow-2xl overflow-hidden">
        <div className="p-6 border-b border-slate-800 flex justify-between items-center text-left">
          <div className="flex items-center gap-3">
            <div className="bg-amber-500/20 p-2 rounded-lg">
              <SafeIcon icon={FiAlertTriangle} className="text-amber-500 w-5 h-5" />
            </div>
            <h2 className="text-xl font-bold text-white">Flag as NLA</h2>
          </div>
          <button onClick={onClose} className="text-slate-400 hover:text-white transition-colors">
            <SafeIcon icon={FiX} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div className="bg-slate-950 rounded-xl p-4 border border-slate-800 text-left">
            <div className="text-[10px] font-black text-slate-500 uppercase tracking-widest mb-1">Part to Flag</div>
            <div className="text-white font-mono font-bold">{part.look_up_pn}</div>
            <div className="text-xs text-slate-400 truncate">{part.descrip1}</div>
          </div>

          <div className="space-y-2 text-left">
            <label className="text-xs font-bold text-slate-400 uppercase tracking-wider">Why is this part NLA?</label>
            <textarea 
              className="w-full bg-slate-950 border border-slate-800 rounded-xl p-4 text-sm text-white focus:border-amber-500 outline-none h-32 resize-none transition-all"
              placeholder="e.g. Supplier confirmed discontinued, no stock found at major distributors..."
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              required
            />
            <p className="text-[10px] text-slate-500 italic">Optional: Adding notes helps admins verify the status faster.</p>
          </div>

          <div className="flex gap-3 pt-4">
            <button type="button" onClick={onClose} className="flex-1 py-3 text-slate-400 font-bold hover:bg-slate-800 rounded-xl transition-colors">
              Cancel
            </button>
            <button 
              type="submit" 
              disabled={isSubmitting}
              className="flex-2 px-8 py-3 bg-amber-600 hover:bg-amber-500 disabled:bg-slate-800 text-white font-black rounded-xl transition-all flex items-center justify-center gap-2"
            >
              {isSubmitting ? 'SUBMITTING...' : <><SafeIcon icon={FiSend} /> SUBMIT REPORT</>}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FlagNLAModal;